const frFR = {
  'action.adjust': 'Ajuster les paramètres',
  'action.applyCrop': 'Appliquer et régénérer',
  'action.applyRecommended': 'Taille recommandée',
  'action.applySize': 'Appliquer la taille',
  'action.cancel': 'Annuler',
  'action.cancelConversion': 'Annuler la conversion',
  'action.chooseImage': 'Choisir une image',
  'action.clearDraft': 'Effacer les données de récupération',
  'action.close': 'Fermer',
  'action.contribute': 'Contribuer',
  'action.copyLink': 'Copier le lien',
  'action.cropRegion': 'Rogner une zone',
  'action.downloadOffline': 'Télécharger hors ligne',
  'action.exportBuildSheet': 'Exporter la fiche de montage',
  'action.exportCsv': 'Exporter en CSV',
  'action.exportPattern': 'Exporter le motif',
  'action.exportPng': 'Exporter le motif codé en PNG',
  'action.exportShareCard': 'Exporter la carte de partage',
  'action.loadProject': 'Ouvrir un projet',
  'action.markColorDone': 'Marquer la couleur comme terminée',
  'action.markColorUndone': 'Marquer comme non terminée',
  'action.ok': 'Compris',
  'action.print': 'Imprimer / Paginer',
  'action.regenerate': 'Régénérer avec ces réglages',
  'action.reportIssue': 'Signaler un problème',
  'action.resetCrop': 'Réinitialiser à l’image entière',
  'action.resetMaking': 'Réinitialiser la progression',
  'action.restoreDraft': 'Restaurer le travail en cours',
  'action.restoreFullImage': 'Rétablir l’image complète',
  'action.saveProject': 'Enregistrer le projet éditable (sans image source)',
  'action.share': 'Partager',
  'action.showAllColors': 'Tout afficher',
  'action.star': 'Étoiler sur GitHub',
  'action.startMaking': 'Commencer la création',
  'action.trySample': 'Essayer un exemple',
  'advanced.autoConfigured': 'Configuré automatiquement par le mode simplifié',
  'advanced.title': 'Paramètres avancés',
  'advice.expressiveness': 'capacité actuelle',
  'advice.kicker': 'Contrôle de définition',
  'advice.perBead': 'pixels source par perle',
  'advice.text': 'La grille actuelle ne permet pas de préserver tous les détails de cette image complexe.',
  'advice.title': 'Réglez le cadrage sur un sujet plus précis',
  'app.heading': 'Bead Grid Studio : Générateur de motifs de perles à repasser',
  'app.skipCanvas': 'Aller au canevas du motif',
  'aria.boardLayout': 'Disposition des plaques',
  'aria.chooseColor': 'Choisir {code} {name}',
  'aria.closeControls': 'Fermer les paramètres',
  'aria.closeCrop': 'Fermer le rognage',
  'aria.closeMaking': 'Fermer l’assistant de montage',
  'aria.closePalette': 'Fermer le nuancier',
  'aria.closeProduct': 'Fermer les informations',
  'aria.closeShare': 'Fermer le partage',
  'aria.codesOff': 'Masquer les codes couleur',
  'aria.codesOn': 'Afficher les codes couleur',
  'aria.codesZoom': 'Codes couleur actifs ; zoomez pour les voir',
  'aria.communityActions': 'Communauté et code source',
  'aria.controls': 'Paramètres du motif',
  'aria.copyStats': 'Copier la liste complète au format texte pour la commande',
  'aria.cropPreview': 'Aperçu du rognage',
  'aria.focusColor': 'Isoler {code}, reste {count} perle(s)',
  'aria.help': 'Aide, confidentialité et version',
  'aria.localPromises': 'Engagements de traitement local et hors ligne',
  'aria.makingActions': 'Contrôles de l’assistant de montage',
  'aria.makingProgress': 'Progression du montage',
  'aria.markColorDone': 'Marquer {code} comme terminé',
  'aria.markColorUndone': 'Marquer {code} comme non terminé',
  'aria.mobilePanels': 'Volets mobiles',
  'aria.nextColor': 'Couleur suivante',
  'aria.paletteRange': 'Système de nuancier',
  'aria.paletteSeries': 'Filtrer par famille de couleurs',
  'aria.paletteStats': 'Nuancier et décompte des matériaux',
  'aria.patternCanvas': 'Grille de {cols} sur {rows} cases. Flèches pour se déplacer, Espace pour peindre, Suppr pour effacer.',
  'aria.presets': 'Préréglages de côté long',
  'aria.preview': 'Mode d’affichage',
  'aria.previousColor': 'Couleur précédente',
  'aria.printImage': 'Modèle prêt pour l’impression',
  'aria.printSheet': 'Grille imprimable',
  'aria.projectLicense': 'Projet et licences',
  'aria.readyActions': 'Actions pour le motif prêt',
  'aria.redo': 'Rétablir',
  'aria.searchPalette': 'Rechercher une nuance',
  'aria.sharePreview': 'Aperçu de la carte',
  'aria.sizeMode': 'Méthode de dimensionnement',
  'aria.stage': 'Aperçu et éditeur de grille',
  'aria.statShare': '{percent} du total des perles',
  'aria.steps': 'Comment ça marche',
  'aria.tools': 'Outils de dessin',
  'aria.undo': 'Annuler',
  'aria.viewOptions': 'Options d’affichage',
  'aria.zoom': 'Zoom du canevas',
  'aria.zoomIn': 'Zoom avant',
  'aria.zoomOut': 'Zoom arrière',
  'board.artkal50': 'Artkal Mini 2,6 mm · 50×50 cases / plaque',
  'board.artkal78': 'Artkal Mini 2,6 mm · 78×78 cases / plaque',
  'board.compatibilityNote': 'Les plaques de 50 et 52 cases peuvent avoir des espacements incompatibles. Choisissez la plaque exacte en votre possession.',
  'board.initialText': 'Après avoir choisi une image, la taille occupée, les marges, le nombre de plaques et les dimensions finales s’affichent ici.',
  'board.initialTitle': 'Plaque 52×52 · Le motif conserve ses proportions',
  'board.layout.1x1': '1×1 plaque',
  'board.layout.1x2': '2 plaques de haut',
  'board.layout.2x1': '2 plaques de large',
  'board.layout.2x2': '2×2 plaques',
  'board.layout.2x3': '2×3 plaques',
  'board.layout.3x2': '3×2 plaques',
  'board.midi14': 'Petite 5 mm · 14×14 cases / plaque',
  'board.midi29': 'Standard 5 mm · 29×29 cases / plaque',
  'board.mini26': 'Petite mini 2,6 mm · 26×26 cases / plaque',
  'board.mini52': 'Mini standard 2,6 mm · 52×52 cases / plaque',
  'board.profile': 'Plaque physique',
  'board.statusBody': '{profile} × {count} plaque(s) ; env. {width}×{height} cm. Centré : {left}/{right} col. vides, {top}/{bottom} lignes vides, {blank} cases libres.',
  'board.statusTitle': 'Plaque {boardCols}×{boardRows} · Motif {patternCols}×{patternRows} (sans étirement)',
  'brand.aria': 'Bead Grid Studio',
  'brand.name': 'Bead Grid Studio',
  'brand.tagline': 'Générateur de motifs pour perles à repasser',
  'canvas.help': 'Utilisez les touches fléchées pour déplacer le curseur, Espace pour peindre, et Suppr pour effacer la case.',
  'confirm.boardQualityLow': '\n\nNote de netteté : une seule plaque convient aux illustrations simples. Pour une photo complexe, prévoyez 104 cases ou plus.',
  'confirm.boardQualitySevere': '\n\nAvertissement de netteté : cette plaque ne peut conserver que les contours principaux et grands aplats ; le texte et les détails fins ne seront pas lisibles.',
  'confirm.boardSwitch': 'Passer au format {profile}, {tilesX}×{tilesY} plaques et générer « Motif {patternCols}×{patternRows} / Plaque {boardCols}×{boardRows} » ? Les modifications manuelles seront remplacées, mais annulables.{quality}\n\nContinuer ?',
  'confirm.clear': 'Effacer le motif actuel ? Cette action peut être annulée.',
  'confirm.clearDraft': 'Cette action efface uniquement les données de récupération du navigateur, pas vos fichiers téléchargés. Effacer ?',
  'confirm.coverCrop': 'Remplir ce canevas rogne environ {percent}% de l’image source. Vérifiez que le sujet n’est pas en bordure. Continuer ?',
  'confirm.exportIssues': 'Ce motif {issues}. Il est recommandé d’augmenter la taille ou de corriger au pinceau. Exporter quand même ?',
  'confirm.loadProject': 'Le motif actuel a des modifications non enregistrées. Charger un autre projet l’écrasera. Cliquez sur Annuler pour sauvegarder d’abord.\n\nAbandonner les modifications et continuer ?',
  'confirm.patternMode': 'Passer en mode Détail du motif et extraire la grille {cols}×{rows} ? Les modifications manuelles seront remplacées, mais annulables. Continuer ?',
  'confirm.printPages': 'Ce motif de {cols}×{rows} sera divisé en pages de {span}×{span} cases max ({pages} pages). Chaque page inclut coordonnées, repères et matériel. Continuer ?',
  'confirm.replaceImage': 'Le motif actuel a des modifications non enregistrées. Choisir une autre image l’écrasera. Cliquez sur Annuler pour sauvegarder d’abord.\n\nAbandonner les modifications et continuer ?',
  'confirm.resetMaking': 'Réinitialiser toute la progression du montage ? Le motif restera inchangé.',
  'confirm.resize': 'Passer à {cols}×{rows} et régénérer depuis l’image source ? Vos retouches actuelles seront remplacées, mais restaurables via Annuler.{quality}\n\nContinuer ?',
  'confirm.resizeQuality': '\n\nAvertissement de netteté : seules environ {cells} cases utiles subsistent. Les détails fins disparaîtront.',
  'conversion.analyzing': 'Analyse de l’image et du nuancier…',
  'conversion.backgroundRemoved': ', fond périphérique retiré',
  'conversion.colorsMerged': ', réduit de {before} à {after} couleurs',
  'conversion.progress': 'Traitement en mode {mode} · jusqu’à {colors} couleurs…',
  'conversion.title': 'Génération du motif en cours',
  'crop.height': 'Hauteur zone %',
  'crop.help': 'Glissez un rectangle sur l’image ou entrez les pourcentages ci-dessous. Isolez un seul sujet à la fois pour un résultat bien plus net.',
  'crop.left': 'Marge gauche %',
  'crop.precise': 'Rognage précis (% de l’image source)',
  'crop.sourcePixels': '{width} × {height} pixels source',
  'crop.title': 'Rogner la zone à réaliser',
  'crop.top': 'Marge haute %',
  'crop.width': 'Largeur zone %',
  'csv.code': 'Code',
  'csv.completed': 'Terminé',
  'csv.count': 'Quantité',
  'csv.hex': 'HEX référence écran',
  'csv.name': 'Nom de couleur',
  'csv.no': 'Non',
  'csv.yes': 'Oui',
  'draft.clear': 'Effacer les données de récupération',
  'draft.restore': 'Restaurer le travail en cours',
  'dropzone.note': 'Détecte le type d’image, calibre les noirs et blancs et préserve les proportions. Vérifiez vos plaques et nuanciers réels avant de commencer.',
  'dropzone.title': 'Choisir une image · Générer un motif de perles',
  'export.boardCopy': '{profile} × {tilesX}×{tilesY} plaque(s) · Motif {cols}×{rows}',
  'export.boardSize': 'Motif {patternCols}×{patternRows} · Plaque {boardCols}×{boardRows} · {boards} plaque(s)',
  'export.count': '{count} perle(s)',
  'export.generated': 'Bead Grid Studio v{version} · généré localement',
  'export.header': '{title} · {cols} col. × {rows} lignes · {colors} couleurs · {beads} perles',
  'export.materials': 'Liste des fournitures',
  'export.patternCopy': 'Dimensions selon le ratio de l’image source',
  'export.patternSize': '{cols} colonnes × {rows} lignes',
  'export.sizeSummary': 'Dimensions : {size} · repères toutes les {step} cases',
  'export.subtitle': 'Nuances compatibles MARD 221 · {board} · repères toutes les {step} cases · codes par case',
  'export.total': 'Total des perles nécessaires : {count}',
  'field.fitMode': 'Ajustement de l’image',
  'field.lightBackground': 'Fond clair',
  'field.maxColors': 'Couleurs maximales dans ce motif',
  'field.maxColorsNote': 'La correspondance automatique choisit les nuances les plus proches du nuancier actif. Cela limite les couleurs utilisées par ce motif.',
  'field.mergeNote': 'Une valeur plus élevée réduit les couleurs quasi identiques tout en conservant les contours sombres et accents vifs.',
  'field.mergeStrength': 'Fusionner les couleurs proches',
  'field.processMode': 'Mode de conversion',
  'field.protectDark': 'Protection des noirs neutres',
  'field.protectDarkNote': 'Évite que les pixels noirs compressés ou réfléchissants ne soient confondus avec du bleu marine, du brun ou du violet.',
  'field.referenceOpacity': 'Superposition de l’image source',
  'file.cropped': 'Rognage · {width}×{height} pixels source',
  'file.details': '{width} × {height} · {size} Mo{suffix}',
  'file.patternFallback': 'bead-pattern',
  'file.restored': 'Dimensions d’origine restaurées',
  'file.trimmed': ' · cadrage automatique sur le sujet',
  'fit.contain': 'Afficher l’image entière',
  'fit.cover': 'Remplir et rogner',
  'footer.license': 'Licence libre',
  'footer.notices': 'Mentions tierces',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'hero.flow1': 'Déposer l’image',
  'hero.flow2': 'Générer la grille',
  'hero.flow3': 'Nuancer les couleurs',
  'hero.flow4': 'Compter les perles',
  'hero.flow5': 'Exporter le modèle',
  'hero.local': '100% exécuté localement dans votre navigateur',
  'hero.noAccount': 'Sans compte',
  'hero.noInstall': 'Sans installation',
  'hero.noUpload': 'Sans envoi en ligne',
  'hero.offline': 'Fonctionne hors ligne',
  'hero.text': 'Déposez une image, faites correspondre les couleurs, comptez les perles et exportez une grille imprimable case par case.',
  'hero.title': 'Image → Motif perles à repasser',
  'history.boardChanged': 'spécification de plaque modifiée',
  'history.cleared': 'motif effacé',
  'history.converted': 'image convertie',
  'history.edited': 'motif modifié',
  'history.keyboardDraw': 'dessiné au clavier',
  'history.keyboardErase': 'effacé au clavier',
  'history.mirroredH': 'miroir horizontal appliqué',
  'history.mirroredV': 'miroir vertical appliqué',
  'history.rotated': 'rotation de 90° vers la droite',
  'history.sizeCleared': 'taille du motif modifiée et canevas effacé',
  'history.stroke': 'tracé terminé',
  'history.undoAvailable': '{label} · {count} étape(s) annulable(s)',
  'language.chinese': '中文',
  'language.english': 'EN',
  'language.french': 'Français',
  'language.japanese': 'JA',
  'language.korean': 'KO',
  'language.label': 'Langue de l’interface',
  'legend.codesZoom': 'Zoomez pour afficher les codes couleur',
  'legend.empty': 'Les codes couleur et quantités apparaissent après la conversion',
  'legend.title': 'Légende du motif',
  'making.allColors': 'Toutes les couleurs sont affichées',
  'making.allColorsDetail': 'Cliquez sur une ligne de matériel pour isoler à nouveau une couleur',
  'making.allDone': 'Toutes les couleurs sont terminées',
  'making.allDoneDetail': 'Effectuez une dernière vérification avec la fiche de montage',
  'making.chooseColor': 'Choisissez une couleur dans la liste des matériaux',
  'making.focusedCount': 'Il reste {count} perles à vérifier pour cette couleur',
  'making.kicker': 'Assistant de montage',
  'making.progress': '{done}/{total} perles · {colorsDone}/{totalColors} couleurs · {percent}%',
  'making.progressAria': '{percent}% terminé, {colorsDone} couleurs sur {totalColors}',
  'making.title': 'Placer les perles couleur par couleur',
  'meta.description': 'Transformez des images en grilles de perles à repasser éditables et imprimables avec codes couleur, repères et décompte des matériaux. Traitement 100% local.',
  'meta.ogDescription': 'Associez les couleurs, comptez les perles, éditez la grille et exportez un modèle imprimable. Tout est traité localement.',
  'meta.ogLocale': 'fr_FR',
  'meta.ogTitle': 'Bead Grid Studio · Image en motif de perles à repasser',
  'meta.schemaDescription': 'Un générateur local-first transformant des images en modèles de perles à repasser imprimables et modifiables.',
  'meta.schemaName': 'Bead Grid Studio',
  'meta.title': 'Bead Grid Studio — Générateur de motifs pour perles à repasser',
  'mobile.palette': 'Nuancier',
  'mobile.pattern': 'Motif',
  'mobile.stats': 'Quantités',
  'mobile.tools': 'Outils',
  'mode.cartoon': 'Icônes et tracés · Préservation des contours',
  'mode.detail': 'Photo détaillée · Préservation des ombres',
  'mode.document': 'Structure de document · Préservation de la mise en page',
  'mode.photo': 'Photo naturelle · Moyenne de zone',
  'mode.pixel': 'Échantillonnage pixel · Sans lissage',
  'modeHint.cartoon': 'Idéal pour illustrations, dessins au trait et logos. Préserve les contours noirs et petits détails vifs.',
  'modeHint.detail': 'Pour portraits et photos complexes. Renforce le contraste local tout en protégeant les zones sombres.',
  'modeHint.document': 'Pour documents, captures d’écran et schémas. Conserve les lignes et grands aplats tout en atténuant le texte illisible.',
  'modeHint.photo': 'Pour photos, dégradés et lumières douces. Moyenne chaque case dans un espace de lumière linéaire.',
  'modeHint.pixel': 'Pour les images déjà au format pixel art. Lit le pixel central de chaque case sans lissage.',
  'output.major10': 'Toutes les 10 cases (Recommandé)',
  'output.major29': 'Toutes les 29 cases (Plaque 5 mm classique)',
  'output.major5': 'Toutes les 5 cases',
  'output.majorGrid': 'Intervalle des repères gras',
  'output.majorNote': 'L’aperçu à l’écran et la fiche de montage utilisent les mêmes repères gras pour faciliter le repérage et l’assemblage des plaques.',
  'output.subtitle': 'PNG / JSON / Impression',
  'output.title': 'Projet et export',
  'palette.all': 'Tout',
  'palette.black': 'Noir',
  'palette.countAll': '221 couleurs · 9 familles',
  'palette.countSeries': 'Famille {series} · {count} couleurs',
  'palette.note': 'Fournit la base compatible MARD de 221 codes (A/B/C/D/E/F/G/H/M). H1 est transparent et réservé au dessin manuel. La conversion utilise 220 couleurs pleines, avec H2 pour le blanc et H7 pour le noir. Les valeurs HEX sont indicatives.',
  'palette.panel': 'Nuancier et fournitures',
  'palette.provider': 'Base compatible MARD 221 nuances',
  'palette.search': 'Rechercher un code ou une famille',
  'palette.series.A': 'Jaune et orange',
  'palette.series.B': 'Vert',
  'palette.series.C': 'Bleu et cyan',
  'palette.series.D': 'Bleu et violet',
  'palette.series.E': 'Rose',
  'palette.series.F': 'Rouge',
  'palette.series.G': 'Brun et chair',
  'palette.series.H': 'Neutres et gris',
  'palette.series.M': 'Terre et ocre',
  'palette.title': 'Nuancier',
  'palette.transparent': 'Transparent',
  'palette.white': 'Blanc',
  'panel.image': 'Image et conversion',
  'panel.localProcessing': 'Traitement local',
  'panel.tools': 'Outils et réglages',
  'preview.bead': 'Aperçu perles',
  'preview.square': 'Blocs de couleur',
  'print.count': '{code} · {count} perles',
  'print.materials': 'Matériaux sur cette page',
  'print.pageSubtitle': 'Motif entier {cols}×{rows} · Colonnes {startCol}–{endCol} / Lignes {startRow}–{endRow} · Codes compatibles 221',
  'print.pageTitle': '{title} · Page {page}/{pages}',
  'product.colorText': 'Ce logiciel utilise la base compatible MARD 221. Il s’agit d’un outil indépendant sans affiliation avec les marques de perles existantes.',
  'product.colorTitle': 'Nuances et marques déposées',
  'product.intro': 'Bead Grid Studio est une application open source exécutée entièrement dans votre navigateur. Aucun compte, paiement ou conversion dans le cloud.',
  'product.performanceText': 'Les plaques de 50 et 52 cases peuvent avoir des espacements différents. Pour les très grands modèles, le zoom est bridé pour préserver la mémoire.',
  'product.performanceTitle': 'Plaques et performances',
  'product.privacy': 'Confidentialité',
  'product.privacyText': 'L’image d’origine ne quitte jamais votre appareil. Vos projets en cours sont stockés localement sans l’image source et peuvent être effacés à tout moment.',
  'product.privacyTitle': 'Confidentialité et restauration',
  'product.repo': 'Dépôt Open Source',
  'product.step1': 'Choisissez une image et cadrez sur le sujet principal.',
  'product.step2': 'Vérifiez le format, la plaque, le nombre de couleurs et le décompte des perles.',
  'product.step3': 'Exportez la grille avec codes couleur ; utilisez l’impression paginée pour les grands formats.',
  'product.stepsTitle': 'Trois étapes simples',
  'product.terms': 'Conditions',
  'product.title': 'Aide, Confidentialité et Version',
  'product.version': 'Version',
  'project.defaultName': 'bead-pattern-project',
  'project.fileDescription': 'Projet modifiable Bead Grid Studio',
  'project.imageLocal': '{width} × {height} · traité localement',
  'project.importedName': 'Motif importé',
  'project.loadedSubtitle': 'Projet JSON chargé · image source non incluse',
  'project.localOnly': 'Les images sont traitées uniquement dans ce navigateur',
  'project.recoveryFile': 'recovery.bead.json',
  'project.untitled': 'Motif sans titre',
  'prompt.projectName': 'Le nom du projet est stocké dans le JSON. Renommez-le si le nom du fichier source contient des informations personnelles ou un numéro de commande.',
  'punctuation.list': ', ',
  'quality.alreadySize': 'Déjà à {cols}×{rows}',
  'quality.aspectMismatch': 'Incohérence de proportions de la grille',
  'quality.aspectShort': '{cols}×{rows} ne correspond pas aux proportions d’origine ; {result}',
  'quality.aspectTitle': '{cols}×{rows} ne correspond pas au ratio d’origine',
  'quality.aspectWarning': 'Alerte proportions et rognage',
  'quality.cellConflict': 'Conflit de cases',
  'quality.crop': 'Isoler un sujet',
  'quality.cropBody': 'Remplir le canevas coupe environ {percent}% de l’image source. Les éléments proches des bords risquent d’être perdus.',
  'quality.cropChoose': 'Rogner et isoler un sujet',
  'quality.cropPercent': '{percent}% rogné',
  'quality.cropSubject': 'Rogner le sujet',
  'quality.cropSuggestion': 'rognez d’abord sur une zone plus restreinte',
  'quality.cropVerb': 'rogner',
  'quality.cropsContent': 'une partie du contenu de l’image sera coupée',
  'quality.detailBody': '{warning}. Augmentez la taille ou utilisez le pinceau pour restaurer le détail.',
  'quality.detailCollisions': '{count} collision(s) de détails ne peuvent être séparées',
  'quality.detailConflict': 'Certains détails dépassent la grille actuelle',
  'quality.detailIntegrity': '{details} ; aucun artéfact ajouté ni ligne fusionnée indûment',
  'quality.detailShort': '{size} : {warning} ; aucune perle superflue n’a été ajoutée',
  'quality.documentBody': 'À {size}, seuls la mise en page et les aplats subsistent ; le texte ne sera pas lisible. {modeAdvice}À {beadMm} mm par perle, le résultat mesure environ {width}×{height} cm.',
  'quality.documentModeAdvice': 'Basculez vers le mode Structure de document ci-dessous. ',
  'quality.documentTitle': 'Le document complet dépasse la zone de lisibilité',
  'quality.documentWarning': 'Alerte lisibilité de document',
  'quality.fixAspect': 'Corriger le ratio à {cols}×{rows}',
  'quality.fixAspectShort': 'Corriger le ratio',
  'quality.glyphHeight': 'La hauteur des lettres équivaut à environ {height} case(s)',
  'quality.hasMargins': 'd’importantes marges apparaissent',
  'quality.increaseSize': 'Agrandir à {cols}×{rows} · env. {width}×{height} cm à {beadMm} mm',
  'quality.largeStructureOnly': 'Grandes structures uniquement',
  'quality.letterboxBody': 'L’image n’est pas déformée mais environ {percent}% du motif est composé de marges. Seules {cols}×{rows} cases contiennent le visuel. Préférez les proportions d’origine.',
  'quality.marginPercent': '{percent}% de marges',
  'quality.marginVerb': 'laisser des marges',
  'quality.missingDetails': '{count} détail(s) sont plus petits qu’une case',
  'quality.modeOrCropSuggestion': 'passez en mode Structure de document ou rognez l’image',
  'quality.oneSubject': 'Réaliser un seul sujet',
  'quality.outlineOnly': 'Cette taille ne permet de conserver que les contours',
  'quality.outlineShort': '{size} ne peut préserver que les contours principaux et grands aplats.',
  'quality.photoBody': 'Le côté long utile ne fait qu’environ {long} cases ({cells} cases effectives). Les petits détails disparaîtront.',
  'quality.photoDetailTitle': 'La grille actuelle ne peut pas restituer tous les détails photo',
  'quality.pixelsPerBead': 'Environ {count} pixels / perle',
  'quality.smallWarning': 'Alerte détails sur petite grille',
  'quality.sourcePixels': '{x}×{y} pixels source',
  'quality.structureOnlyShort': '{size} ne préserve que la mise en page globale ; {action}',
  'quality.text': 'Le texte et les lignes fines ne resteront pas lisibles',
  'quality.textTooSmall': 'Le texte est trop petit pour être assemblé en perles',
  'quality.title': 'Cette image dépasse la résolution de la grille',
  'ready.kicker': 'Motif prêt 🎉',
  'ready.text': 'Vérifiez le motif, les codes couleur et le nombre de perles avant d’exporter ou de partager.',
  'share.cardFooter': 'github.com/zwhy149/bead-grid-studio',
  'share.cardSubtitle': 'Local • Modifiable • Imprimable • Open Source',
  'share.cardTitle': 'Image → Motif perles à repasser',
  'share.copied': 'Lien copié',
  'share.dialogHelp': 'Les fiches de partage sont créées uniquement à votre demande. Elles ne modifient pas la fiche de montage officielle.',
  'share.dialogTitle': 'Exporter une fiche de partage',
  'share.download': 'Télécharger la carte de partage',
  'share.failed': 'Partage direct indisponible. Le lien a été copié dans le presse-papiers.',
  'share.formatLabel': 'Format de la carte',
  'share.original': 'Original',
  'share.pattern': 'Grille de perles',
  'share.portrait': '3:4 · Pour mobile et réseaux sociaux',
  'share.text': 'J’ai créé ce motif de perles à repasser avec Bead Grid Studio 🫘',
  'share.title': 'Motif de perles à repasser créé avec Bead Grid Studio',
  'share.unavailable': 'Ce projet ne contient pas l’image source, la carte Avant / Après ne peut être générée.',
  'share.wide': '16:9 · Pour X / Reddit / Discord',
  'size.aspectInitial': 'Après avoir choisi une image, les préréglages définissent le côté le plus long sans forcer un format carré.',
  'size.aspectLocked': 'Proportions d’origine verrouillées ({ratio}:1). Un préréglage produit une taille proportionnelle ({cols}×{rows}).',
  'size.aspectUnlocked': 'Proportions libres. Le mode afficher tout ajoute des marges, remplir et rogner coupe le surplus.',
  'size.aspectUnlockedInitial': 'Proportions déverrouillées. Largeur et hauteur ajustables séparément.',
  'size.boardCols': 'Colonnes totales de plaques',
  'size.boardMode': 'Par plaque physique',
  'size.boardRows': 'Lignes totales de plaques',
  'size.lockAspect': 'Conserver les proportions (Recommandé)',
  'size.longSide': ({ size }) => `Côté long ${size}`,
  'size.patternAndBoard': 'Motif {patternCols}×{patternRows} / Plaque {boardCols}×{boardRows}',
  'size.patternHeight': 'Hauteur du motif',
  'size.patternMode': 'Par détail du motif',
  'size.patternOnly': 'Motif {cols}×{rows}',
  'size.patternWidth': 'Largeur du motif',
  'size.subtitle': 'Motif et plaque réglables séparément',
  'size.title': 'Taille du motif',
  'smart.calculating': 'Calcul de la configuration recommandée',
  'smart.cropFirst': 'Rogner une zone d’abord',
  'smart.custom': 'Paramètres personnalisés',
  'smart.customAspect': 'La taille personnalisée ne correspond pas aux proportions de l’image',
  'smart.customCapacity': 'Actuel {cols}×{rows} compte environ {cells} cases utiles. Agrandissez ou rognez le sujet.',
  'smart.customIssues': 'Actuel {cols}×{rows} : {warning}. Passez à la taille supérieure ou retouchez au pinceau.',
  'smart.customMismatch': 'Cela provoquera environ {percent}% de {effect}. Utilisez Corriger le ratio ci-dessous.',
  'smart.customSummary': 'Actuel {cols}×{rows}, jusqu’à {colors} couleurs. Vous pouvez rétablir la recommandation automatique à tout moment.',
  'smart.customTooSmall': 'La taille personnalisée est trop petite pour conserver autre chose que les contours',
  'smart.defaultSummary': 'Choisit automatiquement la taille, le mode de conversion, le nuancier et l’affichage.',
  'smart.detailWarning': '{warning} ; passez à {size} cases ou retouchez au pinceau.',
  'smart.documentSummary': 'À {cols}×{rows} max, seuls la mise en page et les aplats subsistent. Rognez sur la zone précise que vous souhaitez réaliser.',
  'smart.documentUnreadable': 'Un document texte entier ne peut pas devenir un motif de perles lisible',
  'smart.generate': 'Générer automatiquement',
  'smart.generatedReview': 'Généré — vérifiez avant d’exporter',
  'smart.generatedSmallLine': 'Optimisation des contours sur petite grille terminée',
  'smart.generatedWithWarning': 'Généré, mais {warning}',
  'smart.kicker': 'Mode automatique en un clic',
  'smart.readySummary': '{size} · {beads} perles · {colors} couleurs · proportions d’origine conservées. {framing}{detailWarning}Env. {width}×{height} cm à {beadMm} mm. Vérifiez les nuances réelles avant de commencer.',
  'smart.recommendedReady': 'Configuration recommandée prête',
  'smart.recommendedSummary': '{cols}×{rows} · {capacity} cases · jusqu’à {colors} couleurs · {trimmed}base compatible MARD 221 · noir et blanc calibrés · codes par case',
  'smart.regenerate': 'Régénérer',
  'smart.restore': 'Rétablir la recommandation automatique',
  'smart.step1': '1 Ajouter l’image',
  'smart.step2': '2 Vérifier le motif',
  'smart.step3': '3 Exporter',
  'smart.trimmed': 'Environ {percent}% d’espace blanc périphérique a été retiré. Vous pouvez rétablir l’image complète à tout moment.',
  'smart.trimmedShort': 'marges extérieures réduites d’env. {percent}% · ',
  'stats.colors': 'Couleurs utilisées',
  'stats.copyList': 'Copier la liste d’achat',
  'stats.empty': 'Cases vides',
  'stats.emptyList': 'Dès que vous ajoutez une image ou dessinez, les quantités de perles s’affichent ici.',
  'stats.listLine': '{code} {name} · {count} perles · {percent}',
  'stats.listMeta': 'Motif : {cols} × {rows} cases · {total} perles au total · {colors} couleurs',
  'stats.listTip': 'Des variations de teinte peuvent exister entre marques et lots. Vérifiez avec un nuancier réel avant de commander et prévoyez ~10% de marge.',
  'stats.listTitle': 'Liste d’achat de perles à repasser (Bead Grid Studio)',
  'stats.sorted': 'Trié par quantité',
  'stats.title': 'Décompte des fournitures',
  'stats.total': 'Total de perles',
  'status.boardPattern': 'motif {patternCols}×{patternRows} / plaque {boardCols}×{boardRows}',
  'status.boardSwitched': 'Spécification de plaque physique modifiée',
  'status.browserUnsupported': 'Ce navigateur ne peut pas lancer la conversion sécurisée en arrière-plan',
  'status.canvasFit': 'Motif ajusté à la fenêtre',
  'status.canvasOverview': 'Vue d’ensemble · zoomez pour éditer',
  'status.cleared': 'Motif effacé',
  'status.complexPreview': 'Aperçu document complexe',
  'status.conversionBlocked': 'Conversion en cours · actions de modification bloquées',
  'status.conversionCanceled': 'Conversion annulée et motif précédent restauré',
  'status.conversionComplete': 'Conversion terminée · {mode} · {size} · {colors} couleurs',
  'status.conversionFailed': '{reason} · motif précédent restauré',
  'status.cropSuggested': 'rognez d’abord sur une zone',
  'status.csvExported': 'CSV des fournitures exporté · {colors} couleurs · {beads} perles',
  'status.documentPreview': '{kind} · texte illisible · {size} · {advice}',
  'status.draftCleared': 'Historique de récupération locale effacé',
  'status.exportDone': 'Export de la fiche PNG terminé',
  'status.exportFailed': 'Échec de l’export PNG',
  'status.exporting': 'Génération du PNG haute résolution en cours…',
  'status.failed': 'Échec de la conversion',
  'status.generatingPixel': 'Génération du motif précis {cols}×{rows}…',
  'status.imageReadFailed': 'Impossible de lire l’image',
  'status.loadingSample': 'Chargement de l’exemple…',
  'status.majorGrid': 'Repères gras réglés toutes les {count} cases',
  'status.makingStarted': 'Assistant de montage activé · suivi couleur par couleur',
  'status.makingStopped': 'Assistant de montage fermé · progression conservée',
  'status.mirroredH': 'Miroir horizontal appliqué',
  'status.mirroredV': 'Miroir vertical appliqué',
  'status.modeSuggested': 'passez en mode Structure ou rognez',
  'status.printFailed': 'Échec de l’aperçu d’impression',
  'status.printReady': '{count} page(s) prête(s) pour l’impression · désactivez l’ajustement automatique dans le dialogue d’impression',
  'status.projectDownloadStarted': 'Téléchargement du projet lancé',
  'status.projectLoadFailed': 'Échec du chargement du projet',
  'status.projectLoaded': 'Projet {cols}×{rows} chargé{migration}',
  'status.projectMigration': ' · migré vers la base 221',
  'status.projectRestored': 'Projet inachevé {cols}×{rows} restauré',
  'status.projectSaved': 'Fichier projet enregistré avec succès',
  'status.readingImage': 'Lecture de l’image…',
  'status.ready': 'Prêt · L’ensemble du traitement s’effectue sur cet appareil',
  'status.redo': 'Action rétablie',
  'status.rotated': 'Pivoter de 90° vers la droite',
  'status.sampleFailed': 'Échec du chargement de l’exemple',
  'status.sizeCleared': 'Taille du motif modifiée et canevas effacé',
  'status.smallRefine': 'Ajustement petite grille terminé · {warning} · agrandissez pour plus de détails',
  'status.structurePreview': 'Aperçu structure de document',
  'status.timeout': 'Délai de conversion dépassé',
  'status.undo': 'Action précédente annulée',
  'status.zoom': '{message} · zoom {percent}%',
  'status.zoomValue': 'Zoom {percent}%',
  'title.codesToggle': 'Afficher ou masquer les codes couleur par case',
  'title.codesZoom': 'Les codes couleur sont activés ; zoomez jusqu’à ce que chaque case mesure au moins 14 pixels',
  'title.color': '{code} {name} {hex}',
  'title.fitCanvas': 'Ajuster l’ensemble du motif à la fenêtre',
  'title.redo': 'Rétablir Ctrl+Y',
  'title.toggleCodes': 'Afficher ou masquer les codes couleur par case',
  'title.toggleGrid': 'Afficher ou masquer la grille',
  'title.toggleRuler': 'Afficher ou masquer les règles de coordonnées',
  'title.undo': 'Annuler Ctrl+Z',
  'title.zoomLimit': 'Zoom maximal pour ce motif : {percent}%',
  'toast.boardContainOnly': 'Le mode plaque réelle conserve toujours l’image entière, centrée et sans déformation.',
  'toast.boardTooLarge': 'Cette disposition dépasse la limite de 160 cases. Utilisez moins de plaques.',
  'toast.canvasFit': 'Zoom ajusté à {percent}%',
  'toast.canvasOverview': 'Vue d’ensemble du motif. Zoomez pour modifier les cases individuelles.',
  'toast.chooseImageFirst': 'Veuillez d’abord choisir une image.',
  'toast.codesNeedZoom': 'Vue d’ensemble. Zoomez à 100% pour afficher les codes ; ils figurent toujours sur la fiche imprimable.',
  'toast.colorDone': '{code} marqué comme terminé. Passage à la couleur suivante.',
  'toast.colorSelected': '{code} {name} sélectionné',
  'toast.colorUndone': '{code} marqué comme non terminé.',
  'toast.conversionBusy': 'Conversion en cours. Veuillez patienter ou annuler la conversion.',
  'toast.conversionCanceled': 'Conversion annulée. Le motif précédent a été conservé.',
  'toast.conversionComplete': 'Conversion terminée : {colors} couleurs{background}{merged}',
  'toast.conversionFailed': 'Échec de la conversion, le motif précédent a été restauré.',
  'toast.conversionTimeout': 'La conversion a pris trop de temps et a été annulée. Utilisez le mode Photo détaillée ou réduisez l’image.',
  'toast.cropTooSmall': 'La zone rognée est trop petite. Sélectionnez une zone plus large.',
  'toast.csvExported': 'Liste des fournitures exportée : {colors} couleurs, {beads} perles.',
  'toast.documentDetected': 'Document complexe détecté. Passez en mode Structure ou rognez d’abord le sujet.',
  'toast.documentPreview': 'Aperçu de document prêt ; le texte ne restera pas lisible.',
  'toast.draftCleared': 'Historique de récupération locale effacé.',
  'toast.draftInvalid': 'Données de récupération corrompues et effacées de façon sécurisée.',
  'toast.draftStorage': 'Espace de stockage local saturé. Sauvegardez le fichier projet manuellement.',
  'toast.emptyPicker': 'Une case vide n’a pas de code couleur. Cliquez sur une case colorée.',
  'toast.exportDone': 'Fiche de montage avec codes couleur exportée.',
  'toast.exportFailed': 'Échec de l’export. Réduisez la taille du motif et réessayez.',
  'toast.exportMemory': 'Appareil insuffisant pour créer une image aussi grande. Réduisez la taille ou utilisez l’impression paginée.',
  'toast.generatedWarning': 'Généré, mais {warning}. Augmentez la taille ou retouchez au pinceau.',
  'toast.imageDamaged': 'Image endommagée ou format non pris en charge.',
  'toast.imagePixelsTooLarge': 'L’image a une résolution trop élevée. Réduisez ses dimensions et réessayez.',
  'toast.imageTooLarge': 'Cette image dépasse 24 Mo. Compressez-la avant de réessayer.',
  'toast.invalidImage': 'Fichier image endommagé ou non valide. Utilisez un PNG, JPG, WebP ou GIF standard.',
  'toast.makingReset': 'Progression du montage réinitialisée.',
  'toast.makingStarted': 'Assistant de montage activé : le canevas met en surbrillance la couleur active.',
  'toast.noMaterials': 'Ce motif ne contient encore aucune perle.',
  'toast.photoModeAuto': 'Photo détaillée détectée : passage automatique en mode Photo détaillée pour éviter un calcul trop long.',
  'toast.previewEditZoom': 'Vue d’ensemble. Zoomez pour retoucher.',
  'toast.printFailed': 'Échec de l’aperçu d’impression. Réduisez la taille ou exportez en PNG.',
  'toast.projectDownloadStarted': 'Téléchargement du projet lancé (sans image source).',
  'toast.projectInvalid': 'Format de projet non valide ou version non prise en charge.',
  'toast.projectLoaded': 'Projet chargé avec succès.',
  'toast.projectMigrated': 'Ancien projet 64 couleurs converti vers le nuancier 221 nuances.',
  'toast.projectRestored': 'Projet inachevé restauré sans son image source. Vous pouvez continuer à l’éditer.',
  'toast.projectSaved': 'Projet éditable enregistré dans le fichier choisi (sans image source).',
  'toast.projectTooLarge': 'Le fichier projet est vide ou trop volumineux.',
  'toast.safeDecodeFailed': 'Impossible de décoder cette grande image en toute sécurité. Compressez-la et réessayez.',
  'toast.sampleFailed': 'Impossible de charger l’exemple intégré. Choisissez une image locale.',
  'toast.statsCopied': 'Liste des perles copiée. Collez-la dans vos notes ou bon de commande.',
  'toast.statsCopyFailed': 'Échec de la copie. Veuillez noter les quantités manuellement.',
  'toast.workerUnsupported': 'Navigateur incompatible avec le calcul en arrière-plan. Utilisez une version récente de Chrome, Edge, Firefox ou Safari.',
  'toast.zoomLimit': 'Pour préserver la mémoire, ce motif {cols}×{rows} est limité à un zoom de {percent}%.',
  'tool.brush': 'Pinceau B',
  'tool.clear': 'Effacer le motif',
  'tool.eraser': 'Gomme E',
  'tool.mirrorH': 'Miroir horizontal',
  'tool.mirrorV': 'Miroir vertical',
  'tool.picker': 'Pipette I',
  'tool.rotate': 'Pivoter de 90° vers la droite',
  'tools.subtitle': 'Glisser pour dessiner en continu',
  'tools.title': 'Dessin et transformation',
  'unit.beads': '{formatted} perles',
  'unit.colors': '{count} couleurs',
  'unit.colorsValue': '{count} couleurs',
  'view.codes': 'Codes',
  'view.fit': 'Ajuster',
  'view.grid': 'Grille',
  'view.ruler': 'Règles',
  'white.auto': 'Laisser vide automatiquement',
  'white.keep': 'Conserver les perles blanches',
};
export default frFR;
